<div *ngIf="reportType == 'CreditNotebriefly'">
   
    <div class="container" id="print-section">
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th colspan="2">Vivek Saptahik</th>
                    <th colspan="2">Advt. Credit Note Register</th>
                    <th colspan="4">Date : {{currentDate | date: 'dd-MM-yyyy' }} </th>
                </tr>
                <tr>
                    <!-- <th colspan="1">Datewise</th> -->
                    <th colspan="3">Briefly</th>
                    <th colspan="1"></th>
                    <th colspan="4">Date From  {{startDate | date: 'dd-MM-yyyy'}} To {{endDate | date: 'dd-MM-yyyy'}}</th>
                </tr>
                <tr>
                    <th>Credit <br>Note No</th>
                    <th>CR Date</th>
                    <th>Advertiser Name</th>
                    <th>Reprensantive <br>Name</th>
                    <th>Office<br>Rep Name</th>
                    <th colspan="2">Credit Note Amount</th>
                    <th>Total Credit<br>Note  Amount</th>
                </tr>
                <tr>
                    <th colspan="5"></th>
                    <th style="text-align: center;">TDS</th>
                    <th style="text-align:center;">Other</th>
                </tr>
                
            </thead>

            <tbody *ngFor="let data of advtCreditRegiInBrieflyFormBeans; let i = index" >
                <tr *ngFor="let data1 of data.rep_data; let i = index">
                    <td>{{data1.rcpt_no}}</td>
                    <td>{{data1.rcpt_date}}</td>
                    <td  style="font-weight:bold">{{data1.advt_name | slice : 0:30}} </td>
                    <td>{{data1.rep_name}}</td>
                    <td>{{data1.office_rep}}</td>
                    <td style="text-align: end;font-weight:bold">{{(data1.tds_amt * 1).toFixed(2)}}</td>
                    <td style="text-align: end;font-weight:bold">{{(data1.other_credit_amt * 1).toFixed(2)}}</td>
                    <td style="text-align: end;font-weight:bold">{{(data1.rec_amt * 1).toFixed(2)}}</td>
                    
                    
                </tr>

                <!-- <tr>
                    <td colspan="5" style="font-weight: bold; text-align: end;">Total:</td>
                    <td colspan="3" style="font-weight: bold;text-align: end;  ">{{data.total}}</td>
                </tr> -->
            </tbody>

           
                <tr>
                  <td colspan="4" style="text-align: center; font-weight: bold; font-size: medium; background-color: #e9ecef !important; color: #0c0d0e !important;">Total:</td>
                  <td colspan="2" style="text-align: end;font-weight: bold; font-size: medium; background-color: #e9ecef !important; color: #0c0d0e !important;">{{(CredittadvtInBrieflyTotaltds * 1).toFixed(2)}}</td>
                  <td colspan="1" style="text-align: end;font-weight: bold; font-size: medium; background-color: #e9ecef !important; color: #0c0d0e !important;">{{(CredittadvtInBrieflyTotalother * 1).toFixed(2)}}</td>
                  <td colspan="1" style="text-align: end;font-weight: bold;  font-size: medium;background-color: #e9ecef !important; color: #0c0d0e !important;">{{(CredittadvtInBrieflyTotal * 1).toFixed(2)}}</td>
                </tr>
             
        </table>
        <!-- </div> -->
    </div>

    <div style="margin-left: 80%;  margin-bottom: 2%;">
       <button 
  class="noPrint" 
  style="margin: 2% 2% 0 2%;" 
  (click)="exportExcel('Datewise_Subscription_Report')" 
  mat-raised-button 
  color="primary">
  Export
</button>

        <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary"
           [useExistingCss]="true"
            printSectionId="print-section" ngxPrint>
            print
        </button>
        
        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>
</div>